import { useEffect, useState } from 'react';
import { useApiRequest } from './useApiRequest';

/**
 * Whether Training is open for a project (Commandment V - it unlocks at Stage 7, after Stage 6
 * Risk Analysis is approved). Reads GET /projects/:id/training/availability, which is
 * member-only and not itself stage-gated; the UI never computes the stage itself.
 *
 * `available` is true / false once known and null while unknown (no project, loading, or the
 * request failed). Callers treat only an explicit false as "closed".
 */
export function useTrainingAvailability(projectId, enabled = true) {
    const { request } = useApiRequest();
    const [state, setState] = useState({ available: null, reason: null, loading: !!projectId && enabled });

    useEffect(() => {
        if (!projectId || !enabled) {
            setState({ available: null, reason: null, loading: false });
            return undefined;
        }
        let cancelled = false;
        setState((s) => ({ ...s, loading: true }));
        request('GET', `/projects/${projectId}/training/availability`)
            .then(({ data }) => {
                if (!cancelled) setState({ available: !!data.trainingAvailable, reason: data.reason || null, loading: false });
            })
            .catch(() => {
                if (!cancelled) setState({ available: null, reason: null, loading: false });
            });
        return () => {
            cancelled = true;
        };
    }, [projectId, enabled, request]);

    return state;
}
